import * as styles from "./BreedListingCard.module.scss";

import React from "react";

import LinkNoStyle from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export interface BreedCardProps {
	name: string;
	description: string;
	shedding: string;
	size: string;
	activityLevel?: string;
	imgSrc: string;
	imgAlt: string;
	url: string;
}

export const BreedListingCard: React.FC<BreedCardProps> = ({
	name,
	description,
	shedding,
	size,
	imgSrc,
	imgAlt,
	url,
}) => {
	return (
		<article key={name} className={styles.cardcontainer}>
			<span className={styles.cardimagewrapper}>
				<ProcessedImage
					className={styles.cardimage}
					src={imgSrc}
					alt={imgAlt}
					dimensions="400x300"
					width={368}
					height={276}
					loading={"lazy"}
				/>
			</span>
			<span className={styles.carddetailscontainer}>
				<LinkNoStyle className={styles.cardanchor} to={url} aria-label={name}>
					<span className={styles.nametext}>{name}</span>
				</LinkNoStyle>
				<span className={styles.breedtext}>{description}</span>
				<span className={styles.carddetails}>{`Size: ${size}`}</span>
				<span
					className={styles.sheddingdetails}
				>{`Shedding: ${shedding}`}</span>
			</span>
		</article>
	);
};

export default BreedListingCard;
